/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComponenteNucleoMinDTO } from './componente-nucleo-min-dto';
import { PraticaCittadinoScadenzaBandoDTO } from './pratica-cittadino-scadenza-bando-dto';
import { ComuneCittadinoMinDTO } from './comune-cittadino-min-dto';
import { TipoPraticaCittadinoMinDTO } from './tipo-pratica-cittadino-min-dto';
import { PraticaCittadinoEsitoGraduatoriaDTO } from './pratica-cittadino-esito-graduatoria-dto';


export interface PraticaCittadinoListItemDTO { 
    id?: string;
    codice_pratica?: string;
    tipo_pratica?: TipoPraticaCittadinoMinDTO;
    comune?: ComuneCittadinoMinDTO;
    stato_dettaglio?: PraticaCittadinoListItemDTOStatoDettaglioEnum;
    stato_cittadino?: PraticaCittadinoListItemDTOStatoCittadinoEnum;
    timestamp_richiesta?: string;
    inizio_lavorazione?: string;
    timestamp_conferma_pratica?: string;
    scadenza_bando?: PraticaCittadinoScadenzaBandoDTO;
    nucleo_familiare?: Array<ComponenteNucleoMinDTO>;
    has_voucher?: boolean;
    esito_graduatoria?: PraticaCittadinoEsitoGraduatoriaDTO;
}
export enum PraticaCittadinoListItemDTOStatoDettaglioEnum {
    IN_ATTESA_OTP = 'IN_ATTESA_OTP',
    RICHIESTA_SOTTOMESSA = 'RICHIESTA_SOTTOMESSA',
    RICHIESTA_IN_LAVORAZIONE = 'RICHIESTA_IN_LAVORAZIONE',
    RICHIESTA_ACCETTATA = 'RICHIESTA_ACCETTATA',
    RICHIESTA_RIFIUTATA = 'RICHIESTA_RIFIUTATA',
    VOUCHER_ASSEGNATI = 'VOUCHER_ASSEGNATI',
    VOUCHER_CONSEGNATI = 'VOUCHER_CONSEGNATI'
};
export enum PraticaCittadinoListItemDTOStatoCittadinoEnum {
    DA_COMPLETARE = 'DA_COMPLETARE',
    IN_VALUTAZIONE = 'IN_VALUTAZIONE',
    ACCETTATA = 'ACCETTATA',
    RIFIUTATA = 'RIFIUTATA'
};



